import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { deleteSalary } from "../../../../../MyApi/hr/salary";


import icons from "../../../../../Data/icons";


const SingleBouns = ({ bouns ,refetch ,openModal}) => {
  const navigate = useNavigate()
  const { id,name , amount  ,amount_type } = bouns;
  
 const mutation = useMutation(["deletesalary" ,id] ,()=>deleteSalary(id),{
  onSuccess:(data)=>{
    refetch()
    toast.success(`${data.message}`)
  },onError:(error)=>{
    toast.error(`${error.response.data.message}`)
  }
 })
 
 const EditPen = icons.pen
 const deletePost =()=>{
  mutation.mutate()
 }
 

  return (
    <tr>
      <td><b>{name} #{id}</b> <br></br></td>
      <td>{amount} {amount_type === 'percent' ? '%' : '$'}</td>
   
      <td>
         <div>
        <div role="group" class="btn-group">
            <button class="btn btn-success" onClick={()=>openModal(id)}><i class="fa fa-eye"></i></button>
           <button class="btn btn-danger"  onClick={deletePost}><i class="fa fa-trash"></i></button></div>
      </div>
      </td>
       
      
         
    </tr>
  );
};

export default SingleBouns;
